import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//guards
import { LoggedinGuard } from './guards/loggedin/loggedin.guard';

import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { AddmenuComponent } from './addmenu/addmenu.component';
import { TemplateComponent } from './template/template.component';
import { AssignmenuComponent } from './assignmenu/assignmenu.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {	path: 'login',	component:LoginComponent 	},
  {	path: 'admin',	component:AdminComponent 	},
  {	path: 'addmenu',	component:AddmenuComponent 	},
  {	path: 'addtemplate',	component:TemplateComponent 	},
  {	path: 'assignmenu',	component:AssignmenuComponent 	},
  {	path: 'forgotpassword/:token',	component:ForgotpasswordComponent 	},
  
  { path: 'wisefly', loadChildren: './wisefly/wisefly.module#WiseflyModule' ,canActivate: [LoggedinGuard]}
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/app/app.routing.ts